import React from "react";
import { useNavigate } from "react-router-dom";
import BrokerLogo from "./BrokerLogo";
import BrokerPageHeader from "./BrokerPageHeader";
import "./Brokers.css";

const brokerOptions = [
  {
    type: "dhan",
    name: "Dhan",
    description: "Connect your Dhan trading account",
    path: "/brokers/add/dhan",
  },
  {
    type: "fyers",
    name: "Fyers",
    description: "Connect your Fyers trading account",
    path: "/brokers/add/fyers",
  },
];

const AddBroker = () => {
  const navigate = useNavigate();

  return (
    <main className="broker-page">
      <BrokerPageHeader
        title="Add New Broker"
        subtitle="Choose the broker you want to connect"
        step="Step 1 of 3"
        backTo="/brokers"
      />

      <section className="broker-select-grid">
        {brokerOptions.map((broker) => (
          <article className="broker-select-card" key={broker.type}>
            <BrokerLogo type={broker.type} />
            <h2>{broker.name}</h2>
            <p>{broker.description}</p>
            <button className="broker-primary-button" onClick={() => navigate(broker.path)}>
              Select {broker.name}
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </article>
        ))}
      </section>

      <div className="broker-page-footer">
        <button className="broker-secondary-button" onClick={() => navigate("/brokers")}>Cancel</button>
      </div>
    </main>
  );
};

export default AddBroker;
